export enum RouteReorganizationType {
  MERGE = 'MERGE',
  SPLIT = 'SPLIT',
}
